<template>
  <Container
    title="Confirme alguns dados"
    subtitle="Confirme alguns dados relacionados ao seu perfil"
    @on-submit="submit"
  >
    <template #form>
      <v-row class="d-flex justify-center align-center flex-column text-center">
        <v-col cols="10">
          <v-form ref="form" @submit.prevent>
            <h5 class="secondary-font font-weight-bold">Estado Civil</h5>
            <v-row class="justify-center">
              <v-radio-group v-model="estadoCivil" row color="primary">
                <v-radio label="Casado" value="casado"></v-radio>
                <v-radio label="Solteiro" value="solteiro"></v-radio>
                <v-radio label="Divorciado" value="divorciado"></v-radio>
              </v-radio-group>
            </v-row>
            <h5 class="secondary-font font-weight-bold mt-4">
              Tem filhos?
            </h5>
            <v-row class="justify-center">
              <v-radio-group v-model="temFilhos" row color="primary">
                <v-radio label="Sim" :value="true"></v-radio>
                <v-radio label="Não" :value="false"></v-radio>
              </v-radio-group>
            </v-row>
            <h5 class="secondary-font font-weight-bold mt-4">
              Número de filhos
            </h5>
            <v-row no-gutters class="mt-4 justify-center">
              <v-col cols="6">
                <v-text-field v-model="filhos" outlined readonly :disabled="!temFilhos" hide-details>
                  <template #append>
                    <v-btn
                      @click="() => (filhos < 20 ? filhos++ : filhos)"
                      :disabled="!temFilhos"
                      class="rounded-lg mr-1 py-3"
                      color="primary"
                      x-small
                      ><v-icon size="16">mdi-plus</v-icon></v-btn
                    >
                    <v-btn
                      @click="() => (!!filhos ? filhos-- : filhos)"
                      :disabled="!temFilhos"
                      class="rounded-lg py-3"
                      color="primary"
                      x-small
                      ><v-icon size="16">mdi-minus</v-icon></v-btn
                    >
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </template>
  </Container>
</template>

<script>
import fichaClinicaService from '@/services/fichaClinica'

const Container = () => import('@/modules/FichaClinica/FichaClinicaContainer')

export default {
  components: {
    Container
  },
  data: () => ({
    estadoCivil: 'casado',
    filhos: 0,
    temFilhos: false
  }),
  methods: {
    async submit() {
      this.$showLoading()

      const filhos = this.temFilhos ? this.filhos : 0

      try {
        await fichaClinicaService.saveDados({
          estadoCivil: this.estadoCivil,
          filhos
        })
        this.$router.push('perguntas')
      } catch (error) {
        this.$showErrorMessage(error.response.data.message)
      } finally {
        this.$hideLoading()
      }
    }
  }
}
</script>

<style scoped>
.v-radio >>> label {
  font-size: 14px;
}
</style>
